import Connection from '../connection';

const BASE_PATH = '/auth';

export function logout() {
  const URL = '/logout';
  return Connection.send(`${BASE_PATH}${URL}`, {}, 'POST');
}

export function loadUser() {
  const URL = '/dashboardUser';
  return Connection.send(`${BASE_PATH}${URL}`).then(response => (response.user));
}



// WEBPACK FOOTER //
// ./src/services/api/auth.js